"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.CurrentRouteContent = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1;\n  grid-template-rows: 3rem 1fr;\n\n  width: 100%;\n"])));

exports.Wrapper = Wrapper;

var CurrentRouteContent = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: calc(100vh - 3rem); // 3rem porque es el alto que tiene el header en 'grid-template-rows'\n  padding: 0 2rem;\n"])));

exports.CurrentRouteContent = CurrentRouteContent;